import { useEffect, useState } from "react";
import classes from './days.module.scss';
import moment from "moment";
import ShowMore from "./showmore";
import ReactGA from 'react-ga4';
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import SingleSliderCard from "../NewProposalDesign/SingleSliderCard";
import { AccoSvg, AccomodationSvg, ActSvg, ActualActivitySvg, ActualCarRentalSvg, ActualFerrySvg, ActualFlightSvg, ActualInsuranceSvg, ActualRestaurantSvg, ActualTrainSvg, CalendarSvg, CallingSvg, CancellationSvg, CarCompanySvg, CarSvg, CartButtonSelectedSvg, CartButtonSvg, CircleTickSvg, CommentSvg, CruiseSvg, DangerCircleSvg, DayDetailsSvg, DaySummarySvg, DownSvg, DownloadSvg, FerrySvg, FlightSvg, ImportantInfoSvg, InsuranceSvg, PersonSvg, RedDotSvg, RestaurantSvg, RightArrowSvg, SmallEmailSvg, StarsSvg, TrainSvg, TransferSvg } from "../../constants/resources";
import { checkSpacing, keyExistInObject, Time } from "../../atom/utilities/function";
import AccommodationModal from "./Common/AccommodationModal";
import FlightModal from "./Common/FlightModal";
import CarModal from "./Common/CarModal";
import TrainModal from "./Common/TrainModal";
import ActRest from "./Common/ActRest";
import FerryModal from "./Common/FerryModal";
import * as Actions from '../../store/actions';
import { ActualDate } from "./Common/timezone";
import showMessage from './Common/notification';
import Helper from '../../Helper';
import { ItineraryAccommodation, UserProfile } from "../../atom/Types";
import { RootState } from "../../App";
import { useAuth0, User } from "@auth0/auth0-react";
import AccoEmail from "../../atom/AccoEmail";
import { useMutation } from "@apollo/client";
import { SEND_EMAIL, UPDATE_BOOKING_STATUS_ACCO } from "../../graphQL/mutations";
import { getENVData } from "../../constants/constantValue";
import TimeFormat from "./Common/timeformat";
import CachedLink from '../CachedLink';

const Days = (props: any) => {
    let i: number = 0;
    const { buliddata, setbuilddata, selectArray, setSelectedArray, setCartItems, cartItems, days } = props;
    const [activeNode, setActiveNode] = useState('');
    const ShareType = useSelector((state: any) => state.Question.ShareType);
    const { Profile } = useSelector((state: RootState) => state?.Question);
    const { user } = useAuth0()

    const [dateNode, setDate] = useState<number>(-1);
    const [confirmModal, setConfirmModal] = useState<number>(0)
    const [accomodationModal, setAccomodationModal] = useState(false);
    const [activeAccomodation, setActiveAccomodation]: any = useState({});

    const [activeFlight, setActiveFlight]: any = useState([]);
    const [flightInfoModal, setFlightInfoModal] = useState(false);

    const [carRental, setCarRental] = useState<boolean>(false)
    const [activeCarRental, setActiveCarRental] = useState<any>([])


    const [trainModal, setTrainModal] = useState<boolean>(false)
    const [activeTrain, setActiveTrain] = useState<any>([])


    const [ferryModal, setFerryModal] = useState<boolean>(false)
    const [activeferry, setActiveFerry] = useState<any>([])

    const [currentIndices, setCurrentIndices] = useState<any>([])
    const [suggestedModal, setSuggestedModal] = useState(false)
    const [suggesionData, setSuggesionData] = useState<any>([])
    const [loader, setLoader] = useState<boolean>(false)

    const [updateAcco] = useMutation(UPDATE_BOOKING_STATUS_ACCO, { variables: {} })
    const [Email] = useMutation(SEND_EMAIL, {
        onError: (error) => {

        }
    })
    const env = getENVData()
    const today = new Date();
    const todayYear = +(today.getFullYear());
    const todayMonth = +(today.getMonth());
    const todayDay = +(today.getDate());

    function isToday(dateString: string) {
        // Parse the input string into a Date object
        const inputDateItems = dateString.split('T');

        if (inputDateItems.length === 2) {
            dateString  = inputDateItems[0];
        }

        const inputDateParts = dateString.split('-');
        const inputYear = +(inputDateParts[0]);
        const inputMonth = +(inputDateParts[1]) - 1; // Months are zero-indexed
        const inputDay = +(inputDateParts[2]);

        // Compare year, month, and day using UTC methods
        return (
            todayYear === inputYear &&
            todayMonth === inputMonth &&
            todayDay === inputDay
        );
    }
    const typesToRender = [
        "flight",
        "cruises",
        "transfer",
        "activity",
        "carRental",
        "train",
        "Restaurant",
        "accommodation",
        "insurances",
        "ferry",
    ];

    const dispatch = useDispatch()

    useEffect(() => {
        let temp: any = []
        for (let index = 0; index < buliddata?.days.length; index++) {
            temp.push({ start: 0, accoStart: 0, accoEnd: window.innerWidth > 600 ? 1 : 0, end: window.innerWidth > 600 ? 1 : 0 })
        }
        setCurrentIndices(temp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.innerWidth])

    console.log(currentIndices, 'currentIndices');


    const handleExpedia = async (event: any, node: any, day: any) => {
        event.returnValue = false;
        event.preventDefault();
        console.log(`Clicked! ${node.url}`);

        const cache: Cache = await caches.open(Helper.CACHE_NAME);

        // 2. Check if the file URL already exists in the cache
        let response: Response | undefined = await cache.match(node.url);

        if (response) {
            // 3. Cache miss: Fetch from network and save to cache
            console.log('File successfully served from local cache!');

            const blob: Blob = await response.blob();
            const localUrl: string = URL.createObjectURL(blob);

            // 6. Trigger forced silent download
            // const downloadLink: HTMLAnchorElement = document.createElement('a');
            // downloadLink.href = localUrl;
            // downloadLink.download = node.url;

            // document.body.appendChild(downloadLink);
            // downloadLink.click();
            // document.body.removeChild(downloadLink);

            window.open(localUrl, '_blank', 'noopener, noreferrer');

            // // 7. Open the file in a new browser tab
            // const newWindow: Window | null = window.open(localUrl, '_blank', 'noopener,noreferrer');
            // if (!newWindow) {
            //     console.warn('Popup blocker prevented opening the file.');
            // }

            // 8. Clean up object URL memory
            setTimeout(() => URL.revokeObjectURL(localUrl), 10000);
        }
        else {
            let itineraryData = day.dayAccommodations.find((a: any) => a.confirmations.find((c: any) => c.name === node.name));

            itineraryData.itineraryDay = {
                itinerary: {
                    name: buliddata?.name,
                    travelAnswer: {
                        sharedEmails: buliddata?.travelAnswer?.sharedEmails || [],
                    }
                }
            };

            try {
                const pdf = await Helper.sendToExpediaPromise("expediaConfirmationPdf", {
                    onNotify: (title: string, message: string, type: "success" | "danger" | "info" | "default" | "warning") => {
                        showMessage(title, message, type);
                    },
                    params: {
                        itineraryData: itineraryData,
                        endUser: true,
                        download: true,
                        open: false,
                        processDate: new Date(),
                        cancel: () => {
                            ;
                        }
                    }
                });

                if (pdf) {
                    const response = new Response(pdf, {
                        headers: { 'Content-Type': 'application/pdf' }
                    });

                    await cache.put(node.url, response);
                }
            }
            catch (ex: any) {
                if (ex) {
                    showMessage("Get expedia itinerary", ex.message || "Invalid request", "danger");
                }
            }
        }

        return false;
    }

    const handleSuggested = (node: any) => {
        const updateData = { ...buliddata };
        const array = [...selectArray];
        let copyCartItems = [...cartItems]; // shallow copy for immutability

        updateData.days.forEach((day: any, index: number) => {
            day.sorted
                .filter((n: any) => n.type === 'activity' || n.type === 'Restaurant')
                .forEach((sug: any) => {
                    if (sug.id === node.id) {
                        sug.selected = !sug.selected;
                    }

                    if (sug.selected && sug.id === node.id) {
                        if (sug.type === 'activity' && sug.bookingStatus === 'InCart') {
                            if (!copyCartItems.some((cartItem: any) => cartItem.id === sug.id)) {
                                copyCartItems.push(sug); // Avoid duplicates
                            }
                        }

                        if (!array.some((item: any) => item.data.id === sug.id)) {
                            array.push({ day: index + 1, data: node });
                            setSelectedArray([...array]); // Update selected array
                        }
                    } else if (!sug.selected && sug.id === node.id) {
                        const reqIndex = copyCartItems.findIndex((cart: any) => cart.id === sug.id);
                        if (reqIndex > -1) {
                            copyCartItems.splice(reqIndex, 1);
                        }

                        const arrayIndex = array.findIndex((n: any) => n.data.id === sug.id);
                        if (arrayIndex > -1) {
                            array.splice(arrayIndex, 1);
                            setSelectedArray([...array]); // Update selected array
                        }
                    }
                });
        });
        setCartItems(copyCartItems);
        dispatch(Actions.cartLength(copyCartItems.length))
        localStorage.setItem(buliddata.key, JSON.stringify(copyCartItems));
        setbuilddata({ ...updateData });
        setSuggestedModal(false); // Close modal after updates
    };

    const handleFerry = (node: any, index: any) => {
        const updateData: any = { ...buliddata }
        const updatedArray = [...selectArray]
        const updatedCartItems = [...cartItems];
        updateData.days[index].sorted.filter((n: any) => { return n.type === 'ferry' }).forEach((ferry: any) => {
            if (ferry.id === node.id) {
                ferry.selected = !ferry.selected
            }
            else {
                ferry.selected = false
            }
            if (ferry.selected) {
                if (!updatedCartItems.some((item) => item.id === node.id)) {
                    updatedCartItems.push(node);
                }
                if (!updatedArray.some((item) => item.data.id === node.id)) {
                    updatedArray.push({ day: node.day, data: node });
                }
            }
            else {
                const reqIndex = updatedCartItems.findIndex((cart) => cart.id === ferry.id);
                if (reqIndex > -1) updatedCartItems.splice(reqIndex, 1);

                const arrayIndex = updatedArray.findIndex((n) => n.data.id === ferry.id)
                if (arrayIndex > -1) updatedArray.splice(arrayIndex, 1);
            }
        })
        setSelectedArray(updatedArray);
        setCartItems(updatedCartItems);
        dispatch(Actions.cartLength(updatedCartItems.length));
        localStorage.setItem(buliddata.key, JSON.stringify(updatedCartItems));
        setbuilddata({ ...updateData });
    }


    const handleCarRental = (node: any, index: any) => {
        const updateData: any = { ...buliddata }
        const updatedArray = [...selectArray]
        const updatedCartItems = [...cartItems];
        updateData.days[index].sorted.filter((n: any) => { return n.type === 'carRental' }).forEach((car: any) => {
            if (car.id === node.id) {
                car.selected = !car.selected
            }
            else {
                car.selected = false
            }
            if (car.selected) {
                if (!updatedCartItems.some((item) => item.id === node.id)) {
                    updatedCartItems.push(node);
                }
                if (!updatedArray.some((item) => item.data.id === node.id)) {
                    updatedArray.push({ day: node.day, data: node });
                }
            }
            else {
                const reqIndex = updatedCartItems.findIndex((cart) => cart.id === car.id);
                if (reqIndex > -1) updatedCartItems.splice(reqIndex, 1);

                const arrayIndex = updatedArray.findIndex((n) => n.data.id === car.id)
                if (arrayIndex > -1) updatedArray.splice(arrayIndex, 1);
            }
        })
        setSelectedArray(updatedArray);
        setCartItems(updatedCartItems);
        dispatch(Actions.cartLength(updatedCartItems.length));
        localStorage.setItem(buliddata.key, JSON.stringify(updatedCartItems));
        setbuilddata({ ...updateData });

    }

    const handleTransfer = (node: any, index: any) => {
        const updateData: any = { ...buliddata }
        const updatedArray = [...selectArray]
        const updatedCartItems = [...cartItems];
        updateData.days[index].sorted.filter((n: any) => { return n.type === 'transfer' }).forEach((tra: any) => {
            if (tra.id === node.id) {
                tra.selected = !tra.selected
            }
            else {
                tra.selected = false
            }
            if (tra.selected) {
                if (!updatedCartItems.some((item) => item.id === node.id)) {
                    updatedCartItems.push(node);
                }
                if (!updatedArray.some((item) => item.data.id === node.id)) {
                    updatedArray.push({ day: node.day, data: node });
                }
            }
            else {
                const reqIndex = updatedCartItems.findIndex((cart) => cart.id === tra.id);
                if (reqIndex > -1) updatedCartItems.splice(reqIndex, 1);

                const arrayIndex = updatedArray.findIndex((n) => n.data.id === tra.id)
                if (arrayIndex > -1) updatedArray.splice(arrayIndex, 1);
            }
        })
        setSelectedArray(updatedArray);
        setCartItems(updatedCartItems);
        dispatch(Actions.cartLength(updatedCartItems.length));
        localStorage.setItem(buliddata.key, JSON.stringify(updatedCartItems));
        setbuilddata({ ...updateData });

    }

    const handleFlightCart = (node: any, index: number, type: string) => {
        const updateData: any = { ...buliddata }
        const updatedArray = [...selectArray]
        const updatedCartItems = [...cartItems];
        updateData.days[index].sorted.filter((n: any) => { return n.type === "flight" }).forEach((fli: any) => {
            if (fli.id === node.id) {
                if (type === 'there') {
                    fli.selected = !fli.selected
                    if (fli.selected) {
                        if (!updatedCartItems.some((item) => item.id === node.id)) {
                            updatedCartItems.push(node);
                        }
                        if (!updatedArray.some((item) => item.data.id === node.id)) {
                            updatedArray.push({ day: node.day, data: node });
                        }
                    }
                    else {
                        const reqIndex = updatedCartItems.findIndex((cart) => cart.id === fli.id);
                        if (reqIndex > -1) updatedCartItems.splice(reqIndex, 1);

                        const arrayIndex = updatedArray.findIndex((n) => n.data.id === fli.id)
                        if (arrayIndex > -1) updatedArray.splice(arrayIndex, 1);
                    }
                }
                else {
                    fli.returnItineraryFlight.selected = !fli.returnItineraryFlight.selected
                    if (fli.returnItineraryFlight.selected) {
                        if (!updatedCartItems.some((item) => item.id === node.returnItineraryFlight.id)) {
                            updatedCartItems.push(node.returnItineraryFlight);
                        }
                        if (!updatedArray.some((item) => item.data.id === ShareType.id)) {
                            updatedArray.push({ day: node.day, data: node.returnItineraryFlight });
                        }
                    }
                    else {
                        const reqIndex = updatedCartItems.findIndex((cart) => cart.id === fli.returnItineraryFlight.id);
                        if (reqIndex > -1) updatedCartItems.splice(reqIndex, 1);

                        const arrayIndex = updatedArray.findIndex((n) => n.data.id === fli.returnItineraryFlight.id)
                        if (arrayIndex > -1) updatedArray.splice(arrayIndex, 1);
                    }
                }


            }
        })
        setSelectedArray(updatedArray);
        setCartItems(updatedCartItems);
        dispatch(Actions.cartLength(updatedCartItems.length));
        localStorage.setItem(buliddata.key, JSON.stringify(updatedCartItems));
        setbuilddata({ ...updateData });
    }
    const handleFlightPrice = (fli: any) => {
        let price: number = 0
        if (fli.connectionFlights.length > 0) {
            fli.connectionFlights.forEach((n: any) => {
                price += n.publishedPrice
            })
        }
        price += fli.publishedPrice
        return price
    }

    const handleTrainCart = (node: any, index: number) => {
        const updateData: any = { ...buliddata }
        const updatedArray = [...selectArray]
        const updatedCartItems = [...cartItems];

        updateData.days[index].sorted.filter((n: any) => { return n.type === "train" }).forEach((train: any) => {
            if (train.id === node.id) {
                train.selected = !train.selected
            }
            else {
                train.selected = false
            }
            if (train.selected) {

                if (!updatedCartItems.some((item) => item.id === node.id)) {
                    updatedCartItems.push(node);
                }
                if (!updatedArray.some((item) => item.data.id === node.id)) {
                    updatedArray.push({ day: node.day, data: node });
                }
            } else {

                const reqIndex = updatedCartItems.findIndex((cart) => cart.id === train.id);

                if (reqIndex > -1) updatedCartItems.splice(reqIndex, 1);

                const arrayIndex = updatedArray.findIndex((n) => n.data.id === train.id);
                if (arrayIndex > -1) updatedArray.splice(arrayIndex, 1);
            }
        })

        setSelectedArray(updatedArray);
        setCartItems(updatedCartItems);
        dispatch(Actions.cartLength(updatedCartItems.length));
        localStorage.setItem(buliddata.key, JSON.stringify(updatedCartItems));
        setbuilddata({ ...updateData });

    }

    const handleTrain = (node: any, m: any) => {

        const updateData: any = { ...buliddata }
        const array = [...selectArray];
        if (m === 'close') {
            setTrainModal(false)
        }
        else if (m === 'choose') {
            updateData?.days.forEach((n: any, index: number) => n?.sorted?.filter((node: any) => (node.type === "train")).forEach((train: any) => {
                if (train.id === node[0].id) {
                    train.selected = !train.selected
                } else train.selected = false
                if (train.selected) {
                    array.push({ day: index + 1, data: node[0] })
                    setSelectedArray([...array]);
                } else if (train.selected === false) {
                    const index = array.findIndex((n: any) => n.data.id === train.id)
                    if (index > -1) {
                        array.splice(index, 1)
                        setSelectedArray([...array]);
                    }
                }


            }))
            setbuilddata({ ...updateData })
            setTrainModal(false);
        }
        else {
            setActiveTrain(node)
        }
    }
    // const handleFerry = (node: any, m: any) => {

    //     const updateData: any = { ...buliddata }
    //     const array = [...selectArray];
    //     if (m === 'close') {
    //         setFerryModal(false)
    //     }
    //     else if (m === 'choose') {
    //         updateData?.days.forEach((n: any, index: number) => n?.sorted?.filter((node: any) => (node.type === "ferry")).forEach((ferry: any) => {


    //             if (ferry.id === node[0].id) {
    //                 ferry.selected = !ferry.selected

    //             } else ferry.selected = false



    //             if (ferry.selected) {
    //                 array.push({ day: index + 1, data: node[0] })
    //                 setSelectedArray([...array]);
    //             } else if (ferry.selected === false) {
    //                 const index = array.findIndex((n: any) => n.data.id === ferry.id)
    //                 if (index > -1) {
    //                     array.splice(index, 1)
    //                     setSelectedArray([...array]);
    //                 }
    //             }


    //         }))
    //         setbuilddata({ ...updateData })


    //         setFerryModal(false);
    //     }
    //     else {
    //         setActiveCarRental(node)
    //     }
    // }

    const showmoreless = (node: any, innndex: number, date: any) => {


        ReactGA.event({
            category: 'Show More',
            action: `Clicked ${node.type}`,
            label: buliddata.name

        });

        if (activeNode === node.id) {
            setActiveNode('')
        }
        else {
            setActiveNode(node.id)
            setDate(innndex)
        }

    }

    const handleConfirmModal = (node: any) => {

        if (confirmModal === node.daySeqNumber)
            setConfirmModal(0)
        else
            setConfirmModal(node.daySeqNumber)
    }


    const handleDayModal = (node: any, index: number, type: string) => {


        if (node.type === 'accommodation') {
            let updateData = { ...buliddata }
            let temp = updateData.days[index].sorted.filter((n: any) => n.id === node.id)
            temp[0].day = index + 1
            setbuilddata({ ...updateData })
            setAccomodationModal(true)
            setActiveAccomodation(node)
        }
        else if (node.type === 'flight') {
            let updateData = { ...buliddata }
            let temp = updateData.days[index].sorted.filter((n: any) => n.id === node.id)
            temp[0].day = index + 1
            setFlightInfoModal(true)
            if (type === 'there')
                setActiveFlight([node])
            else
                setActiveFlight([node.returnItineraryFlight])
        }
        else if (node.type === 'carRental') {

            setCarRental(true)
            setActiveCarRental([node])
        }
        else if (node.type === 'train') {

            setTrainModal(true)
            setActiveTrain([node])
        }
        else if (node.type === 'ferry') {

            setFerryModal(true)
            setActiveFerry([node])
        }


    }


    const sortNodesByTime = (nodes: any) => {
        return nodes.sort((obj1: any, obj2: any) => {
            const time1 = new Date(obj1.sortTime).getTime();
            const time2 = new Date(obj2.sortTime).getTime();

            if (time1 > time2) return 1;
            if (time1 < time2) return -1;
            return 0;
        });
    };

    useEffect(() => {
        if (days) {
            const sectionId = days.replace('#', '');
            const section = document.getElementById(sectionId);

            if (section) {
                section.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [days]);

    const handleAcco = (node: ItineraryAccommodation, index: number) => {
        const updateData: any = { ...buliddata }
        const updatedArray = [...selectArray]
        const updatedCartItems = [...cartItems];

        updateData.days[index].sorted.filter((n: any) => { return n.type === "accommodation" && n.bookingStatus === 'InCart' }).forEach((acco: any) => {
            if (acco.id === node.id) {
                acco.selected = !acco.selected
            }

            if (acco.selected && acco.id === node.id) {
                if (!updatedCartItems.some((item) => item.id === acco.id)) {

                    updatedCartItems.push(node);
                }
                if (!updatedArray.some((item) => item.data.id === acco.id)) {
                    updatedArray.push({ day: node.day, data: node });
                }
            } else if (!acco.selected && acco.id === node.id) {
                const reqIndex = updatedCartItems.findIndex((cart) => cart.id === acco.id);
                if (reqIndex > -1) updatedCartItems.splice(reqIndex, 1);
                const arrayIndex = updatedArray.findIndex((n) => n.data.id === acco.id);
                if (arrayIndex > -1) updatedArray.splice(arrayIndex, 1);
            }
        })

        setSelectedArray(updatedArray);
        setCartItems(updatedCartItems);
        dispatch(Actions.cartLength(updatedCartItems.length));
        localStorage.setItem(buliddata.key, JSON.stringify(updatedCartItems));
        setbuilddata({ ...updateData });
    }

    const handleReserve = (node: ItineraryAccommodation, e: any) => {
        e.stopPropagation()
        console.log(node, 'nodeeeeee');
        setLoader(true)
        if (node) {
            updateAcco({ variables: { id: node.id, bookingStatus: 'Reserved' } }).then((res) => {
                const email = AccoEmail(buliddata, keyExistInObject(Profile as UserProfile, '') as UserProfile, user as User, node);
                if (email) {
                    Email({
                        variables: {
                            to: env.email,
                            ccEmails: env.subEmail,
                            subject: `${Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') : buliddata?.travelAnswer?.name ? buliddata?.travelAnswer?.name : user?.nickname},  ${buliddata?.name} , has reserved an accommodation`,
                            body: email,
                            submitTime: Date.now()
                        }
                    }).then(() => {
                        setLoader(false)
                        window.location.reload()
                    })
                }
            }).catch(() => {
                setLoader(false)
            })
        }
    }

    const sumOfPersons = (adults: any, child: any) => {
        return adults + child
    }

    const getConfirmations = (d: any): any[] => {
        if (!d) {
            return [];
        }

        const components = [...d.dayFlights, ...d.dayAccommodations, ...d.dayTransfers, ...d.dayInsurances, ...d.dayActivities,
                        ...d.dayCarRentals, ...d.dayCruises, ...d.dayTrains, ...d.dayFerries, ...d.dayRestaurants].filter((c: any) => c.isDeleted !== true && c.bookingStatus === 'Booked');

        const allConfirmations = [...d.confirmation, ...components.flatMap((c: any) => c.confirmations)];
        const results = [...new Map(allConfirmations.map((c: any) => [c.name, c])).values()];

        if (results.length > d.confirmation.length) {
            return results;
        }
        else {
            return d.confirmation;
        }
    }

    return <div className="tet">
        {buliddata?.days?.map((n: any, index: number) => {
            const impInfo = buliddata?.importantInformations?.filter((imp: any) => { return imp?.type === 'Transfer' })

            const filterActRes = n.sorted.filter((n: any) => { return (n.type === "activity" || n.type === "Restaurant") && n.isAddToSuggession && (n.bookingStatus === 'Proposal' || n.bookingStatus === 'InCart') && (n.isVisible || n.isVisible === null) })
            let temp = n?.stayPoint?.split(',')
            i = i + 1
            const cartTrain = n?.sorted?.filter(
                (node: any) => node.type === "train" && node.bookingStatus === 'InCart' && (node.isVisible || node.isVisible === null)
            );
            const cartAcco = n?.dayAccommodations?.filter((node: any) => node.type === "accommodation" && (node.bookingStatus === 'InCart' || node.bookingStatus === 'InReserve') && (node.isVisible || node.isVisible === null));
            // console.log(cartAcco, 'lamoraa');

            const cartTransfer = n?.sorted?.filter((node: any) => node.type === "transfer" && node.bookingStatus === 'InCart' && (node.isVisible || node.isVisible === null));
            const cartFerry = n?.sorted?.filter((node: any) => node.type === "ferry" && node.bookingStatus === 'InCart' && (node.isVisible || node.isVisible === null));

            const InCart = n?.sorted?.filter((node: any) => { return node?.bookingStatus === 'InCart' && node.type !== 'accommodation' })
            const checkAcco = n?.dayAccommodations?.filter((node: any) => { return node?.bookingStatus === 'InCart' })

            const cartFlight = n?.sorted?.filter(
                (node: any) => node.type === "flight" && node.bookingStatus === 'InCart' && (node.isVisible || node.isVisible === null)
            );
            const cartCarRental = n?.sorted?.filter(
                (node: any) => node.type === "carRental" && node.bookingStatus === 'InCart' && (node.isVisible || node.isVisible === null)
            );
            const filteredTrain = n?.sorted?.filter(
                (node: any) => node.type === "train" && node.bookingStatus === 'InProgress' && (node.isVisible || node.isVisible === null)
            );
            const filteredAcco = n?.dayAccommodations?.filter(
                (node: any) => node.type === "accommodation" && (node.bookingStatus === 'InProgress' || node.bookingStatus === 'Reserved') && (node.isVisible || node.isVisible === null)
            );
            const filteredFlight = n?.sorted?.filter(
                (node: any) => node.type === "flight" && node.bookingStatus === 'InProgress' && (node.isVisible || node.isVisible === null)
            );
            const filteredFerry = n?.sorted?.filter(
                (node: any) => node.type === "ferry" && node.bookingStatus === 'InProgress' && (node.isVisible || node.isVisible === null)
            );
            const filteredInsurances = n?.sorted?.filter(
                (node: any) => node.type === "insurances" && node.bookingStatus === 'InProgress' && (node.isVisible || node.isVisible === null)
            );
            const filteredCarRental = n?.sorted?.filter(
                (node: any) => node.type === "carRental" && node.bookingStatus === 'InProgress' && (node.isVisible || node.isVisible === null)
            );
            const filteredTransfer = n?.sorted?.filter(
                (node: any) => node.type === "transfer" && node.bookingStatus === 'InProgress' && (node.isVisible || node.isVisible === null)
            );
            const filteredRestaurant = n?.sorted?.filter(
                (node: any) => node.type === "Restaurant" && n.bookingStatus === 'InProgress' && (node.isVisible || node.isVisible === null)
            );
            const filteredActivity = n?.sorted?.filter((n: any) => { return n.type === "activity" && n.bookingStatus === 'InProgress' })
            const filterImportantInformation = (checkSpacing(n?.importantInformation) || n.contacts.length > 0 || checkSpacing(n?.internalComment)) && ShareType !== "friends" && buliddata.type === 'Actual'
            const filterInformation = (checkSpacing(n?.importantInformation) || n.contacts.length > 0) && ShareType !== "friends" && buliddata.type === 'Actual'
            const filterComment = checkSpacing(n?.internalComment) && ShareType !== "friends" && buliddata.type === 'Actual'

            return <div key={index}>
                <div id={`day${index + 1}`} className={classes.dayContainer}>
                    <div style={{ display: 'flex', flexDirection: 'row', padding: '10px', justifyContent: 'space-between' }}>
                        <div className={isToday(n.date) ? classes.stayPointToday : classes.stayPointGeneral}>
                            <div className={classes.date}>{isToday(n.date) ? <p>Today ({moment.utc(n.date).format("ddd MMM DD YYYY")}) <span>
                                <RedDotSvg />
                            </span></p> : moment.utc(n.date).format("ddd, MMM DD ")}</div>
                            {temp?.length > 1 ? <div style={{ display: 'flex', marginTop: '5px' }}><div className={classes.stayPoint} style={{ fontWeight: '500', color: '#8492A5' }}>{temp[0]}</div>,<div className={classes.stayPoint}>{temp[1]}</div></div> :
                                n?.stayPoint ? <div className={classes.stayPoint}>{n?.stayPoint}</div> : null
                            }
                        </div>

                        <div className={classes.day}>Day {i}</div>

                    </div>
                    <div style={{ display: "flex", flexDirection: 'column', paddingTop: '10px' }}>
                        <div className={classes.dayHeading}> <span>
                            <DaySummarySvg />
                        </span>Day Summary</div>
                        {checkSpacing(n?.details) ? <div className={classes.daydescription} style={{ color: '#545D68' }} dangerouslySetInnerHTML={{ __html: n.details }}></div> : <div className={classes.daydescription} style={{ fontSize: "14px", fontStyle: "italic", color: "lightgray" }}>No summary found</div>}
                    </div>
                    {checkSpacing(n?.description) ? <div style={{ display: "flex", flexDirection: 'column', paddingTop: '10px' }}>
                        <div className={classes.dayHeading}> <span>
                            <DayDetailsSvg />
                        </span>Day Details</div>
                        <div className={classes.dayImage}>
                            <div className={classes.daydescription} dangerouslySetInnerHTML={{ __html: n.description }}></div>
                            <div className={classes.daydescription}>{n?.media[0]?.url ? <img src={n?.media[0]?.url} alt="pic" /> : null}</div></div>
                    </div> : null}

                    {
                        filteredAcco.length > 0 &&
                        filteredAcco.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span>
                                            <AccoSvg width={'24'} height={'24'} />
                                        </span> Accommodation
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' || node.bookingStatus === 'Reserved' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'Booked' ? 'Booked' : node.bookingStatus === 'InProgress' || node.bookingStatus === 'Reserved' ? 'Booking in Progress' : 'Not Booked'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>
                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true || node.bookingStatus === 'Reserved' ? node?.accommodation?.name : `No ${node.type} selected`}</div>
                                    {node.bookingStatus !== 'InProgress' && node.bookingStatus !== 'Reserved' && (node.isVisible || node.isVisible === null) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg />
                                    </span></p> : null}
                                </div>
                            </div>
                        })}

                    {
                        filteredTrain.length > 0 &&
                        filteredTrain.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span><ActualTrainSvg />
                                        </span> Train
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'Booked' ? 'Booked' : node.bookingStatus === 'InProgress' ? 'Booking in Progress' : 'Not Booked'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>
                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true ? node?.train?.trainCompany : `No ${node.type} selected`}</div>
                                    {node.bookingStatus !== 'InProgress' && (node.isVisible || node.isVisible === null) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg />
                                    </span></p> : null}
                                </div>
                            </div>
                        })}
                    {

                        filteredFlight.length > 0 &&
                        filteredFlight.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span>
                                            <ActualFlightSvg />
                                        </span> Flight
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'Booked' ? 'Booked' : node.bookingStatus === 'InProgress' ? 'Booking in Progress' : 'Not Booked'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>

                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true ? node?.flight?.airlineName : `No ${node.type} selected`}</div>
                                    {(node.bookingStatus !== 'InProgress' && (node.isVisible || node.isVisible === null)) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg />
                                    </span></p> : null}
                                </div>
                            </div>
                        })}

                    {
                        filteredFerry.length > 0 &&
                        filteredFerry.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span> <ActualFerrySvg />
                                        </span> Ferry
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'Booked' ? 'Booked' : node.bookingStatus === 'InProgress' ? 'Booking in Progress' : 'Not Booked'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>
                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true ? node?.ferry?.ferryCompany : `No ${node.type} selected`}</div>
                                    {node.bookingStatus !== 'InProgress' && (node.isVisible || node.isVisible === null) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg /></span></p> : null}
                                </div>
                            </div>
                        })}

                    {
                        filteredInsurances.length > 0 &&
                        filteredInsurances.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span> <ActualInsuranceSvg />
                                        </span> Insurance
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'Booked' ? 'Booked' : node.bookingStatus === 'InProgress' ? 'Booking in Progress' : 'Not Booked'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>

                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true ? node?.insurance?.provider : `No ${node.type} selected`}</div>
                                    {node.bookingStatus !== 'InProgress' && (node.isVisible || node.isVisible === null) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg /></span></p> : null}
                                </div>
                            </div>
                        })}
                    {
                        filteredCarRental.length > 0 &&
                        filteredCarRental.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span> <ActualCarRentalSvg />
                                        </span> car rental
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'Booked' ? 'Booked' : node.bookingStatus === 'InProgress' ? 'Booking in Progress' : 'Not Booked'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>

                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true ? node?.carType : `No ${node.type} selected`}</div>
                                    {node.bookingStatus !== 'InProgress' && (node.isVisible || node.isVisible === null) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg /></span></p> : null}
                                </div>
                            </div>
                        })}
                    {
                        filteredTransfer.length > 0 &&
                        filteredTransfer.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span> <TransferSvg />
                                        </span> Transfer
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'Booked' ? 'Booked' : node.bookingStatus === 'InProgress' ? 'Booking in Progress' : 'Not Booked'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>

                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true ? node?.carType : `No ${node.type} selected`}</div>
                                    {node.bookingStatus !== 'InProgress' && (node.isVisible || node.isVisible === null) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg /></span></p> : null}
                                </div>
                            </div>
                        })}
                    {
                        filteredRestaurant.length > 0 &&
                        filteredRestaurant.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span> <ActualRestaurantSvg />
                                        </span> Restaurant
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'InProgress' && 'Booking in Progress'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>

                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true ? node?.restaurant?.name : `No ${node.type} selected`}</div>
                                    {node.bookingStatus !== 'InProgress' && (node.isVisible || node.isVisible === null) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg /></span></p> : null}
                                </div>
                            </div>
                        })}
                    {
                        filteredActivity.length > 0 &&
                        filteredActivity.map((node: any, innndex: number) => {
                            return <div key={innndex} style={{ display: "flex", flexDirection: 'column', paddingTop: '5px' }}>
                                <div className={classes.dayHeading} style={{ justifyContent: `space-between` }}>
                                    <div>
                                        <span> <ActualActivitySvg />
                                        </span> Activity
                                    </div>
                                    <p className={classes.dayText} style={{
                                        color: `${node.bookingStatus === 'Booked' ? '#1CC255' :
                                            node.bookingStatus === 'InProgress' ? '#FF8A00' : '#8492A5'}`
                                    }}>{node.bookingStatus === 'InProgress' && 'Booking in Progress'}</p>
                                </div>
                                <div className={classes.daydescription} style={{ padding: '5px', display: 'flex', justifyContent: 'space-between' }}>
                                    <div >{node.bookingStatus === 'InProgress' || node?.selected === true ? node?.activity?.name : `No ${node.type} selected`}</div>
                                    {node.bookingStatus !== 'InProgress' && (node.isVisible || node.isVisible === null) ? <p onClick={() => handleDayModal(node, index, '')} className={classes.dayText} style={{ fontSize: '14px', color: '#0279CF', cursor: 'pointer' }}> see all options<span style={{ marginLeft: '7px' }}>
                                        <RightArrowSvg /></span></p> : null}
                                </div>
                            </div>
                        })}


                    {filterImportantInformation ? <div style={{ background: '#EAEFF4', borderRadius: '16px', padding: '32px 16px' }}>{
                        filterInformation ? <div style={{ display: "flex", flexDirection: 'column', alignItems: 'flex-start', paddingTop: '10px' }}>
                            <div className={classes.dayHeading}> <span>
                                <ImportantInfoSvg />
                            </span>Important Information</div>
                            <div className={classes.daydescription} style={{ color: '#545D68' }} dangerouslySetInnerHTML={{ __html: n.importantInformation }}></div>
                            {n.contacts.length > 0 ? <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {n.contacts.map((node: any, index: number) => {
                                    return <div key={index}>
                                        <div className={classes.dayHeading}>{n.contacts.length > 1 ? `Contact Details ${index + 1}` : 'Contact Details'}</div>
                                        <div className={classes.contactSize}><div>Name</div><div style={{ color: '#0279CF' }}>{node?.name}</div></div>
                                        <div className={classes.contactSize}><div>Email</div><div style={{ color: '#0279CF' }}><CachedLink className={classes.email} rel="noreferrer" target="_blank" href={"mailto:" + node?.email}>{node?.email}</CachedLink></div></div>
                                        <div className={classes.contactSize} style={{ gap: '10px' }}><div >Phone Number</div><div style={{ color: '#0279CF' }}><CachedLink style={{ color: '#0279CF' }} href={"tel://" + node?.phone}>{node?.phone}</CachedLink></div></div>
                                    </div>
                                })}
                            </div> : null}
                        </div> : null}

                        {filterComment ? <div style={{ display: "flex", flexDirection: 'column', alignItems: 'flex-start', paddingTop: '20px' }}>
                            <div className={classes.dayHeading}> <span>
                                <CommentSvg />
                            </span>Comment from Travelsment</div>
                            <div className={classes.daydescription} style={{ color: '#545D68' }} dangerouslySetInnerHTML={{ __html: n.internalComment }}></div></div> : null}
                    </div> : null}

                    {getConfirmations(n).length > 0 && ShareType !== "friends" && buliddata?.type === 'Actual' ? <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingBottom: '10px', gap: '5px' }}>
                        <div onClick={() => { handleConfirmModal(n) }} className={classes.confirmHead}>Confirmations and docs <span >{confirmModal === n.daySeqNumber ?
                            <DownSvg rotate={'rotate(180deg)'} /> : <DownSvg rotate={'rotate(0deg)'} />}</span></div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '177px', gap: '8px', flexDirection: 'column' }}>
                            {confirmModal === n.daySeqNumber ? getConfirmations(n).map((node: any, idx: number) =>
                                <div key={idx} className={classes.confirmdesc}>{node.url && node.url.includes("/expedia") ? <>
                                    <CachedLink rel="noreferrer" href="#" onClick={(e) => handleExpedia(e, node, n)}>{node?.name}</CachedLink>
                                    <div><CachedLink rel="noreferrer" href="#" download onClick={(e) => handleExpedia(e, node, n)}>
                                        <DownloadSvg />
                                    </CachedLink></div>
                                </> : <>
                                    <CachedLink download rel="noreferrer" href={node?.url} target="_blank">{node?.name}</CachedLink>
                                    <div><CachedLink rel="noreferrer" download href={node?.url} target="_blank">
                                        <DownloadSvg />
                                    </CachedLink></div>
                                </>}
                                </div>) : null}
                        </div></div> : null}
                    {checkSpacing(n?.cancellationPolicy) && ShareType !== "friends" && buliddata?.type === 'Actual' ? <div style={{ display: "flex", flexDirection: 'column', alignItems: 'flex-start', paddingTop: '10px' }}>
                        <div className={classes.dayHeading}> <span>
                            <CancellationSvg />
                        </span>Cancellation Policy</div>
                        <div className={classes.daydescription} dangerouslySetInnerHTML={{ __html: n?.cancellationPolicy }}></div>
                    </div> : null}

                    <div className={classes.displayArea} >
                        <div>
                            {n?.sorted && sortNodesByTime(n.sorted).map((node: any, innndex: number) => {
                                return (
                                    <div key={innndex} className={classes.displayBock}>
                                        {node.type === "flight" && node?.bookingStatus === 'Booked' ?
                                            <div >
                                                <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                    <button onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey}>
                                                        <FlightSvg width={"35"} height={"25"} />
                                                        {moment.utc(ActualDate(node.departDate)).format("ddd MMM DD YYYY") === moment.utc(ActualDate(buliddata.startDate)).format("ddd MMM DD YYYY") ?
                                                            <span className={activeNode === node.id ? classes.name : ''}><span>Departure</span></span> :
                                                                moment.utc(ActualDate(node.arrivalDate)).format("ddd MMM DD YYYY") === moment.utc(ActualDate(buliddata.endDate)).format("ddd MMM DD YYYY") ?
                                                                    <span className={activeNode === node.id ? classes.name : ''}><span>Arrival</span></span> :
                                                                        <span className={activeNode === node.id ? classes.name : ''}><span>Arrival/Departure</span></span>}
                                                    </button>
                                                </div>
                                            </div> :
                                            node.type === "cruises" && node?.bookingStatus === 'Booked' ?
                                                <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                    <Tooltip title={node?.bookingStatus === 'Booked' && activeNode !== node?.id ? 'click to expand' : node?.bookingStatus === 'Booked' && activeNode === node?.id ? "click to minimize" : "booking is in progress only"}>
                                                        <button disabled={node?.bookingStatus === 'Booked' ? false : true} onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey} >
                                                            <CruiseSvg width={"30"} height={"25"} />
                                                            <span className={activeNode === node.id ? classes.name : ''}><span>Cruise</span></span></button>
                                                    </Tooltip>
                                                </div> :
                                                node.type === "transfer" && node?.bookingStatus === 'Booked' ?
                                                    <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                        <Tooltip title={node?.bookingStatus === 'Booked' && activeNode !== node?.id ? 'click to expand' : node?.bookingStatus === 'Booked' && activeNode === node?.id ? "click to minimize" : "booking is in progress only"}>
                                                            <button disabled={node?.bookingStatus === 'Booked' ? false : true} onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey} >
                                                                <TransferSvg />
                                                                <span className={activeNode === node.id ? classes.name : ''}><span>Transfer</span></span></button>
                                                        </Tooltip>

                                                    </div> :
                                                    node.type === "activity" && node?.bookingStatus === 'Booked' ?
                                                        <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                            <button onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey} >
                                                                <ActSvg />  <span className={activeNode === node.id ? classes.name : ''}><span>{node.activity.name}</span></span></button>

                                                        </div> :
                                                        node.type === "carRental" && node?.bookingStatus === 'Booked' ?
                                                            <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                                <Tooltip title={node?.bookingStatus === 'Booked' && activeNode !== node?.id ? 'click to expand' : node?.bookingStatus === 'Booked' && activeNode === node?.id ? "click to minimize" : "booking is in progress only"}>
                                                                    <button disabled={node?.bookingStatus === 'Booked' ? false : true} onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey} >
                                                                        <CarSvg width={"24"} height={"24"} />
                                                                        <span className={activeNode === node.id ? classes.name : ''}><span>Car Rental</span></span></button>
                                                                </Tooltip>   </div> :
                                                            node.type === "train" && node?.bookingStatus === 'Booked' ?
                                                                <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                                    <Tooltip title={node?.bookingStatus === 'Booked' && activeNode !== node?.id ? 'click to expand' : node?.bookingStatus === 'Booked' && activeNode === node?.id ? "click to minimize" : "booking is in progress only"}>
                                                                        <button disabled={node?.bookingStatus === 'Booked' ? false : true} onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey} >
                                                                            <TrainSvg width={"24"} height={"24"} />
                                                                            <span className={activeNode === node.id ? classes.name : ''}><span>Train</span></span></button>
                                                                    </Tooltip>
                                                                </div> : node.type === "ferry" && node?.bookingStatus === 'Booked' ?
                                                                    <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                                        <Tooltip title={node?.bookingStatus === 'Booked' && activeNode !== node?.id ? 'click to expand' : node?.bookingStatus === 'Booked' && activeNode === node?.id ? "click to minimize" : "booking is in progress only"}>
                                                                            <button disabled={node?.bookingStatus === 'Booked' ? false : true} onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey} >
                                                                                <FerrySvg width={"24"} height={"24"} />
                                                                                <span className={activeNode === node.id ? classes.name : ''}><span>Ferry</span></span></button>
                                                                        </Tooltip>

                                                                    </div> : node.type === "insurances" && node?.bookingStatus === 'Booked' ?
                                                                        <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                                            <Tooltip title={node?.bookingStatus === 'Booked' && activeNode !== node?.id ? 'click to expand' : node?.bookingStatus === 'Booked' && activeNode === node?.id ? "click to minimize" : "booking is in progress only"}>

                                                                                <button disabled={node?.bookingStatus === 'Booked' ? false : true} onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey} >
                                                                                    <InsuranceSvg />
                                                                                    <span className={activeNode === node.id ? classes.name : ''}><span>Insurance</span></span></button>
                                                                            </Tooltip>
                                                                        </div>
                                                                        : node.type === "accommodation" && node?.bookingStatus === 'Booked' && (moment.utc(n.date).utc().format("MMM D YYYY") === moment.utc(node.checkOutDate).utc().format("MMM D YYYY") || moment.utc(n.date).utc().format("MMM D YYYY") === moment.utc(node.checkInDate).utc().format("MMM D YYYY")) ?
                                                                            <div style={{ margin: "10px", position: "relative", display: "flex" }}>

                                                                                <button onClick={() => showmoreless(node, index, n.date)} className={activeNode === node.id && dateNode === index ? classes.blue : classes.grey} >
                                                                                    <AccomodationSvg />
                                                                                    <span className={activeNode === node.id ? classes.name : ''}>
                                                                                        {moment.utc(n.date).format("MMM D YYYY") === moment.utc(node.checkOutDate).format("MMM D YYYY") ? <span>Check Out from {node.accommodation.name}</span> : <span>Check In at {node.accommodation.name}</span>}
                                                                                    </span>
                                                                                </button>

                                                                            </div> : node.type === "Restaurant" && node?.bookingStatus === 'Booked' ?
                                                                                <div style={{ margin: "10px", position: "relative", display: "flex" }}>
                                                                                    <Tooltip title={node?.bookingStatus === 'Booked' && activeNode !== node?.id ? 'click to expand' : node?.bookingStatus === 'Booked' && activeNode === node?.id ? "click to minimize" : "booking is in progress only"}>

                                                                                        <button disabled={node?.bookingStatus === 'Booked' ? false : true} onClick={() => showmoreless(node, innndex, n.date)} className={activeNode === node.id ? classes.blue : classes.grey} >
                                                                                            <RestaurantSvg />
                                                                                            <span className={activeNode === node.id ? classes.name : ''}><span>{node.restaurant.name}</span></span></button>
                                                                                    </Tooltip>

                                                                                </div> : null}   </div>)
                            })}

                        </div>
                    </div>
                    <div className={classes.displayContent} >

                        {n?.sorted?.map((node: any, innndex: number) => (
                            <div key={innndex} style={{ display: "block" }}>
                                {node.type === 'accommodation' ? typesToRender.includes(node.type) && activeNode === node.id && dateNode === index ?
                                    activeNode !== '' ? <ShowMore activeNode={activeNode} node={node} date={dateNode} setActiveNode={setActiveNode} buliddata={buliddata} />
                                        : null : null : typesToRender.includes(node.type) && activeNode === node.id ?
                                    activeNode !== '' ? <ShowMore activeNode={activeNode} node={node} date={n.date} setActiveNode={setActiveNode} buliddata={buliddata} />
                                        : null : null
                                }
                            </div>))
                        }
                    </div>

                </div>
                {filterActRes.length > 0 ?
                    <>
                        <p className={classes.sliderHead}><span><StarsSvg />Tours and Activities</span></p>
                        <div className={classes.grids}>
                            {filterActRes.filter((sug: any, ind: number) => { return ind >= currentIndices[index]?.start && ind <= currentIndices[index]?.end }).map((node: any, indd: number) => {
                                return <div key={indd}>
                                    <SingleSliderCard
                                        handleAcco={handleAcco}
                                        handleSuggested={handleSuggested}
                                        index={index}
                                        end={filterActRes.length}
                                        singleNode={node}
                                        setCurrentIndices={setCurrentIndices}
                                        currentIndices={currentIndices}
                                        ind={indd}
                                        scrollIndex={index}
                                        setSuggesionData={setSuggesionData}
                                        setSuggestedModal={setSuggestedModal} />
                                </div>
                            })}
                        </div>
                        <hr className={classes.border} />

                    </> : null}

                {
                    cartTransfer.length > 0 ?
                        <>
                            <div className={classes.dayTrainSec}>
                                <p className={classes.sliderHead}>
                                    Transfer
                                </p>
                                {
                                    cartTransfer.map((tra: any) => {
                                        return <div style={{ marginBottom: '8px', width: '100%' }}>
                                            <div className={classes.trainContent} style={{ padding: '16px', flexDirection: 'column', gap: '8px', alignItems: 'flex-start', color: '#273443' }} onClick={() => handleTransfer(tra, index)}>
                                                <p className={classes.traHead}>{tra?.transferType}</p>
                                                <p style={{ fontWeight: '700', fontSize: '16px' }}>{tra?.startPoint} - {tra?.finishPoint}</p>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><PersonSvg /><p style={{ fontWeight: '500', fontSize: '16px' }}>Number of People: {sumOfPersons(tra?.adults, tra?.children)}</p></div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><CalendarSvg width={"16"} height={"16"} color={"#273443"} /><p style={{ fontWeight: '500', fontSize: '16px' }}>Pick up time: {moment.utc(tra.transferDate).format('dddd, DD MMMM YYYY')}, {Time(tra?.startTime)}</p></div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <div className={classes.transferContent}>
                                                        <p> Driver </p>
                                                        <CallingSvg /> <span className={classes.callFont}>{tra?.transfer?.providerPhone}</span>
                                                    </div>
                                                    {impInfo.length > 0 && <div className={classes.transferContent} style={{ gap: "8px" }}>
                                                        <p> Support </p>
                                                        <p style={{ display: "flex", flexDirection: 'row', alignItems: 'center' }}> <CallingSvg /> <span className={classes.callFont}>{impInfo[0]?.contact}</span></p>
                                                        <p style={{ display: "flex", flexDirection: 'row', alignItems: 'center' }}><SmallEmailSvg /> <span className={classes.callFont}>{impInfo[0]?.email}</span></p>
                                                    </div>}
                                                </div>
                                                <div className={classes.instruction}>
                                                    <p style={{ color: '#758191', fontSize: '12px', fontWeight: '500' }}>Instructions</p>
                                                    <p>{checkSpacing(tra?.comment) ? tra?.comment : `No Instructions`}</p>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>

                                                    <div className={classes.head1}>
                                                        <div className={classes.carPubPrice}>
                                                            <p>Full Price</p>
                                                            <p style={{ fontSize: '16px', fontWeight: '400', fontStyle: 'poppins' }}>${tra?.publishedPrice} {tra?.payNow !== null && tra?.payNow > 0 && <Tooltip title={"You’ll have to pay the rest of a Full Property Price at a location!"}><span> <DangerCircleSvg /></span></Tooltip>}</p>

                                                        </div>
                                                        {tra?.payNow > 0 && <div className={classes.traPubPrice} style={{ borderLeft: '1px solid #E0E6ED' }}>
                                                            <p>Pay Now</p>
                                                            <p style={{ fontSize: '16px', fontWeight: '700', fontStyle: 'poppins', color: '#0279CF', }}>$ {tra?.payNow}</p>

                                                        </div>}
                                                    </div>
                                                    <>
                                                        {tra?.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            <hr className={classes.border} />
                        </> : null
                }
                {
                    cartCarRental.length > 0 ?
                        <>
                            <div className={classes.dayTrainSec}>
                                <p className={classes.sliderHead}>
                                    Car Rental
                                </p>
                                {
                                    cartCarRental.map((car: any, ind: number) => {
                                        return <div style={{ backgroundColor: 'white', width: '100%' }}>
                                            <div className={classes.trainContent} onClick={() => handleCarRental(car, index)}>
                                                <div className={classes.logoBox}>
                                                    <img src={car.carRental.media[0]?.url} alt="logo" width={116} height={96} />
                                                </div>
                                                <div className={classes.contentBox}>
                                                    <div className={classes.contentTop}>
                                                        <div className={classes.head1}>
                                                            <div className={classes.carContent}>
                                                                <CarCompanySvg /> {car?.carRental?.companyName}
                                                            </div>
                                                            <p style={{ fontWeight: 700, fontSize: '16px' }}>{car?.carBrand} <span style={{ fontSize: '16px', fontWeight: 400, color: '#758191' }}>or similar</span></p>
                                                        </div>
                                                        <div className={classes.head1}>
                                                            <div className={classes.carContent}>
                                                                {car?.carType}
                                                            </div>
                                                            <div className={classes.carContent}>
                                                                {car?.carAmenities[0]}
                                                            </div>
                                                            <div className={classes.carContent}>
                                                                {car?.doorCount} doors
                                                            </div>
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

                                                            <div className={classes.head1}>
                                                                <div className={classes.carPubPrice}>
                                                                    <p>Full Price</p>
                                                                    <p style={{ fontSize: '16px', fontWeight: '400', fontStyle: 'poppins' }}>${car?.publishedPrice} {car?.payNow !== null && car?.payNow > 0 && <Tooltip title={"You’ll have to pay the rest of a Full Property Price at a location!"}><span> <DangerCircleSvg /></span></Tooltip>}</p>

                                                                </div>
                                                                {car.payNow > 0 && <div className={classes.carPubPrice} style={{ borderLeft: '1px solid #E0E6ED' }}>
                                                                    <p>Pay Now</p>
                                                                    <p style={{ fontSize: '16px', fontWeight: '700', fontStyle: 'poppins', color: '#0279CF', }}>$ {car?.payNow}</p>

                                                                </div>}
                                                            </div>
                                                            <>
                                                                {car?.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}
                                                            </>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            <hr className={classes.border} />

                        </> : null
                }

                {
                    cartFerry.length > 0 ?
                        <>
                            <div className={classes.dayTrainSec}>
                                <p className={classes.sliderHead}>
                                    Ferry
                                </p>
                                {
                                    cartFerry.map((ferry: any, ind: number) => {
                                        return <div style={{ backgroundColor: 'white', width: '100%' }}>
                                            <div className={classes.trainContent} onClick={() => handleFerry(ferry, index)}>
                                                <div className={classes.logoBox}>
                                                    <img src={ferry.ferry.logo?.url} alt="logo" width={116} height={80} />
                                                </div>
                                                <div className={classes.contentBox}>
                                                    <div className={classes.contentTop}>
                                                        <p className={classes.ferryHead}>
                                                            {ferry?.ferry?.ferryCompany}
                                                        </p>
                                                        <p style={{ fontWeight: 700, fontSize: '16px' }}>{ferry?.ferry?.departurePort} - {ferry?.ferry?.arrivalPort} </p>
                                                        <div className={classes.ferryContent}>
                                                            Departure time: {ferry?.ferry?.departurePort}, {moment.utc(ferry?.departDate).format('dddd, MMMM D')}, {Time(ferry?.departTime)}
                                                        </div>
                                                        <div className={classes.ferryContent}>
                                                            Arrival time: {ferry?.ferry?.arrivalPort}, {moment.utc(ferry?.arrivalDate).format('dddd, MMMM D')}, {Time(ferry?.arrivalTime)}
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch' }}>

                                                            <div className={classes.head1}>
                                                                <div className={classes.carPubPrice}>
                                                                    <p> Price</p>
                                                                    <p className={ferry?.payNow !== null && ferry?.payNow > 0 ? classes.priceFont : classes.payFont}>${ferry?.publishedPrice} {ferry?.payNow !== null && ferry?.payNow > 0 && <Tooltip title={"You’ll have to pay the rest of a Full Property Price at a location!"}><span> <DangerCircleSvg /></span></Tooltip>}</p>

                                                                </div>
                                                                {ferry.payNow > 0 && <div className={classes.carPubPrice} style={{ borderLeft: '1px solid #E0E6ED' }}>
                                                                    <p>Pay Now</p>
                                                                    <p className={classes.payFont}>$ {ferry?.payNow}</p>

                                                                </div>}
                                                            </div>
                                                            <>
                                                                {ferry?.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}
                                                            </>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            <hr className={classes.border} />

                        </> : null
                }

                {
                    cartFlight.length > 0 ?
                        <>
                            <div className={classes.dayTrainSec}>
                                <p className={classes.sliderHead}>
                                    Flight
                                </p>
                                {cartFlight.map((flight: any, ind: number) => {
                                    return <div style={{ backgroundColor: 'white', width: '100%' }}>
                                        <div className={classes.trainContent} onClick={() => handleFlightCart(flight, index, 'there')}>
                                            <div className={classes.logoBox}>
                                                <img src={flight?.carRental?.logo?.url} alt="logo" width={116} height={96} />
                                            </div>
                                            <div className={classes.contentBox}>
                                                <div className={classes.contentTop}>
                                                    <p style={{ color: '#0279CF' }}>There</p>
                                                    <p onClick={(e) => { handleDayModal(flight, ind, 'there'); e.stopPropagation() }} style={{ color: '#0279CF', fontWeight: '700', fontSize: '16px', textDecoration: 'underline', cursor: 'pointer' }}>{`${flight.flight.departureAirport} (${flight?.flight?.departure?.airportCode
                                                        ? flight?.flight?.departure?.airportCode
                                                        : flight.flight?.departureAirportCode
                                                        }) - ${flight?.connectionFlights?.length > 0
                                                            ? flight?.connectionFlights[flight?.connectionFlights?.length - 1]?.flight?.arrivalAirport
                                                            : flight?.flight?.arrivalAirport
                                                        } (${flight?.connectionFlights?.length > 0
                                                            ? flight?.connectionFlights[flight?.connectionFlights?.length - 1].flight?.arrival?.airportCode
                                                                ? flight?.connectionFlights[flight?.connectionFlights?.length - 1].flight?.arrival?.airportCode
                                                                : flight?.connectionFlights[flight?.connectionFlights?.length - 1].flight?.arrivalAirportCode
                                                            : flight?.flight?.arrival?.airportCode
                                                                ? flight?.flight?.arrival?.airportCode
                                                                : flight?.flight?.arrivalAirportCode
                                                        })`}</p>
                                                    <p>{`Departure time: ${TimeFormat(flight?.departTime)}, ${moment.utc(flight.departDate).format('MMM Do YYYY')}`}</p>
                                                    <p>
                                                        {`Arrival time: ${flight.connectionFlights?.length > 0
                                                            ? `${Time(flight?.connectionFlights[flight.connectionFlights?.length - 1]?.arrivalTime)}, ${moment.utc(flight?.connectionFlights[flight?.connectionFlights?.length - 1]?.arrivalDate).format('MMM Do YYYY')}`
                                                            : `${Time(flight?.arrivalTime)}, ${moment.utc(flight?.arrivalDate).format('MMM Do YYYY')}`
                                                            }`}
                                                    </p>
                                                </div>
                                                <div className={classes.contentBottom}>
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <p>Price</p>
                                                        <p className={classes.price}>${handleFlightPrice(flight)}</p>
                                                    </div>
                                                    {flight.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}
                                                </div>
                                            </div>
                                        </div>
                                        {flight.returnItineraryFlight !== null ?
                                            <div className={classes.trainContent} onClick={() => handleFlightCart(flight, index, 'back')}>
                                                <div className={classes.logoBox}>
                                                    <img src={flight?.returnItineraryFlight?.flight?.logo?.url} alt="logo" width={116} height={96} />
                                                </div>
                                                <div className={classes.contentBox}>
                                                    <div className={classes.contentTop}>
                                                        <p style={{ color: '#0279CF' }}>Back</p>
                                                        <p onClick={(e) => { handleDayModal(flight, ind, 'back'); e.stopPropagation() }} style={{ color: '#0279CF', fontWeight: '700', fontSize: '16px', textDecoration: 'underline', cursor: 'pointer' }}>
                                                            {flight?.returnItineraryFlight?.flight.departureAirport}
                                                            ({flight?.returnItineraryFlight?.flight?.departure?.airportCode || flight.returnItineraryFlight?.flight.departureAirportCode})
                                                            -
                                                            {flight?.returnItineraryFlight?.connectionFlights?.length > 0
                                                                ? flight?.returnItineraryFlight?.connectionFlights[flight?.returnItineraryFlight?.connectionFlights?.length - 1]?.flight?.arrivalAirport
                                                                : flight.returnItineraryFlight?.flight.arrivalAirport
                                                            }
                                                            ({flight?.returnItineraryFlight?.connectionFlights?.length > 0
                                                                ? flight?.returnItineraryFlight?.connectionFlights[flight?.returnItineraryFlight?.connectionFlights?.length - 1].flight?.arrival?.airportCode
                                                                    ? flight?.returnItineraryFlight?.connectionFlights[flight?.returnItineraryFlight?.connectionFlights?.length - 1].flight.arrival?.airportCode
                                                                    : flight?.returnItineraryFlight?.connectionFlights[flight?.returnItineraryFlight?.connectionFlights?.length - 1].flight.arrivalAirportCode
                                                                : flight?.returnItineraryFlight?.flight.arrival?.airportCode
                                                                    ? flight?.returnItineraryFlight?.flight.arrival?.airportCode
                                                                    : flight?.returnItineraryFlight?.flight.arrivalAirportCode
                                                            })
                                                            `</p>
                                                        <p>{`Departure time: ${Time(flight?.returnItineraryFlight?.departTime)}, ${moment.utc(flight?.returnItineraryFlight?.departDate).format('MMM Do YYYY')}`}</p>
                                                        <p>
                                                            {`Arrival time: ${flight?.returnItineraryFlight?.connectionFlights?.length > 0
                                                                ? `${Time(flight?.returnItineraryFlight?.connectionFlights[flight.returnItineraryFlight?.connectionFlights?.length - 1]?.arrivalTime)}, ${moment.utc(flight?.returnItineraryFlight?.connectionFlights[flight?.returnItineraryFlight?.connectionFlights?.length - 1]?.arrivalDate).format('MMM Do YYYY')}`
                                                                : `${Time(flight?.returnItineraryFlight?.arrivalTime)}, ${moment.utc(flight?.returnItineraryFlight?.arrivalDate).format('MMM Do YYYY')}`
                                                                }`}
                                                        </p>
                                                        <p></p>
                                                    </div>
                                                    <div className={classes.contentBottom}>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <p>Price</p>
                                                            <p className={classes.price}>${flight.returnItineraryFlight?.publishedPrice}</p>
                                                        </div>
                                                        {flight?.returnItineraryFlight?.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}
                                                    </div>
                                                </div>
                                            </div> : null}
                                    </div>
                                })}
                            </div>
                            <hr className={classes.border} />
                        </>
                        : null
                }
                {
                    cartTrain.length > 0 ?
                        <>
                            <div className={classes.dayTrainSec}>
                                <p className={classes.sliderHead}>
                                    Train
                                </p>
                                {cartTrain.map((train: any, ind: number) => {
                                    return <div key={ind} style={{ backgroundColor: 'white', width: '100%' }}><div className={classes.trainContent} onClick={() => handleTrainCart(train, index)}>
                                        <div className={classes.logoBox}>
                                            <img src={train.train.logo?.url} alt="logo" width={116} height={96} />
                                        </div>
                                        <div className={classes.contentBox}>
                                            <div className={classes.contentTop}>
                                                <p style={{ color: '#0279CF' }}>{train.trainNumber}</p>
                                                <p style={{ color: '#273443', fontWeight: '700', fontSize: '16px' }}>{train.train.departureCity}-{train.train.arrivalCity}</p>
                                                <p>{`Departure time: ${Time(train.departTime)}, ${moment.utc(train.departDate).format('MMM Do YYYY')}`}</p>
                                                <p>{`Arrival time: ${Time(train.arrivalTime)}, ${moment.utc(train.arrivalDate).format('MMM Do YYYY')}`}</p>
                                                <p></p>
                                            </div>
                                            <div className={classes.contentBottom}>
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <p>Price</p>
                                                    <p className={classes.price}>${train.publishedPrice}</p>
                                                </div>
                                                {train.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}
                                            </div>
                                        </div>
                                    </div>
                                        {ind !== cartTrain.length - 1 && <hr style={{ width: '100%' }} />}
                                    </div>
                                })}
                            </div>
                            <hr className={classes.border} />
                        </> : null
                }
                {
                    cartAcco.length > 0 ?
                        <>
                            <p className={classes.sliderHead}><span>Select accommodation</span></p>
                            <div className={classes.grids}>
                                {cartAcco.filter((sug: any, ind: number) => { return ind >= currentIndices[index]?.accoStart && ind <= currentIndices[index]?.accoEnd }).map((node: any, indd: number) => {
                                    return <div key={indd}>
                                        <SingleSliderCard
                                            handleReserved={handleReserve}
                                            handleSuggested={handleSuggested}
                                            handleAcco={handleAcco}
                                            index={index}
                                            end={cartAcco.length}
                                            singleNode={node}
                                            setCurrentIndices={setCurrentIndices}
                                            currentIndices={currentIndices}
                                            ind={indd}
                                            scrollIndex={index}
                                            setSuggesionData={setSuggesionData}
                                            setSuggestedModal={setSuggestedModal} />
                                    </div>
                                })}
                            </div>
                        </> : null

                }
                {(InCart.length === 0 && checkAcco.length === 0) && <hr className={classes.border} />}


            </div>
        })}

        {accomodationModal ? <AccommodationModal selectArray={selectArray} setSelectedArray={setSelectedArray} activeAccomodation={activeAccomodation} setAccomodationModal={setAccomodationModal} buliddata={buliddata} setbuilddata={setbuilddata} /> :
            flightInfoModal ? <FlightModal setFlightInfoModal={setFlightInfoModal} buliddata={buliddata} activeFlight={activeFlight} selectArray={selectArray} setSelectedArray={setSelectedArray} setbuilddata={setbuilddata} /> :
                carRental ? <CarModal buliddata={buliddata} activeCarRental={activeCarRental} carDetails={activeCarRental} handleCarRental={handleCarRental} setActiveCarRental={setActiveCarRental} /> :
                    trainModal ? <TrainModal TrainDetails={activeTrain} buliddata={buliddata} handleTrain={handleTrain} activeTrain={activeTrain} setActiveTrain={setActiveTrain} /> :
                        ferryModal ? <FerryModal buliddata={buliddata} ferryDetails={activeferry} handleFerry={handleFerry} activeferry={activeferry} setActiveFerry={setActiveFerry} /> : null}

        {
            suggestedModal ?
                <ActRest suggesionData={suggesionData} setSuggestedModal={setSuggestedModal} handleSuggested={handleSuggested} /> : null
        }
        {
            loader && <div className={classes.ModalBackground}> <div className={classes.Loader}><div></div><div></div><div></div><div></div></div></div>
        }

    </div >
}
export default Days